import { type ExperienceActivationPayload } from '../../../../types/models'
import { type MediaControls } from '../../../media'
import { type IExperienceAdapter } from './experience-adapter'
import { type IAnalytics } from '../analytics/analytics'

export abstract class BaseExperienceAdapter implements IExperienceAdapter {
  abstract analytics (): IAnalytics

  protected onCurrentActivationsUpdateHandler: (items: ExperienceActivationPayload[]) => void = () => {}
  protected onReadyHandler: () => Promise<void> = async () => {}

  onCurrentActivationsUpdate (callback: (items: ExperienceActivationPayload[]) => void) {
    this.onCurrentActivationsUpdateHandler = callback
    return this
  }

  protected setupAnalytics (
    mediaControl: MediaControls
  ) {
    mediaControl.on('play', () => {
      this.analytics().sendAnalytics('play')
    })
    mediaControl.on('pause', () => {
      this.analytics().sendAnalytics('pause')
    })
    mediaControl.on('seeked', () => {
      this.analytics().sendAnalytics('scrub')
    })
  }

  onReady (callback: () => Promise<void>) {
    this.onReadyHandler = callback
    return this
  }

  abstract initialize (): Promise<void>
}
